export default "__VITE_ASSET__f21ec18f__"